import Model from "./Model";

export default class extends Model {
    async loadTable(
      page,
      limit,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_software_id = null,
      version_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_software_id,
                version_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: response.pages,
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(download_log => {
                let telem = {
                    tbody: {}
                };
                telem.id = download_log.id;
                telem.tbody.download_date_time = download_log.download_date_time;
                telem.tbody.message = download_log.message;
                telem.tbody.version_number = download_log.version_number;
                telem.tbody.status_description = download_log.status_description;
                telem.tbody.status_color = download_log.status_color;
                telem.tbody.location_number = download_log.location_number;
                telem.tbody.brand = download_log.brand;
                telem.tbody.client = download_log.client;
                telem.tbody.device_type = download_log.device_type;
                telem.tbody.software = download_log.software;
                telem.tbody.device_ip = download_log.device_ip;
                telem.tbody.location_number = download_log.location_number;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
